/**
 * InputFileDrop
 * @class
 * @constructor
 * @public
 * @version 1.0.0
 */
class InputFileDrop extends HTMLElement {
  constructor() {
    super();
  }

  /**
   * Getters
   */
  
  /**
   * @type HTMLElement | null
   */
  get documentNameElement() {
      return this.querySelector('.document-name');
  }

  /**
   * @type HTMLInputElement | null
   */
  get fileInput() {
    return this.querySelector('input[type="file"]');
  }
  /**
   * connectedCallback
   * Render html/css & attatch event listeners
   */
  connectedCallback() {
    // Add event listeners
    this.addEventListener("dragenter", this);
    this.addEventListener("dragleave", this);
    this.addEventListener("dragover", this);
    this.addEventListener("drop", this);
    this.fileInput.addEventListener("change", this);
  }

  /**
   * disconnectedCallback
   * Remove listeners.
   */
  disconnectedCallback() {
    this.removeEventListener('dragenter', this);
    this.removeEventListener('dragleave', this);
    this.removeEventListener('dragover', this);
    this.removeEventListener('drop', this);
    this.fileInput.removeEventListener('change', this);
  }

  /**
   * handles all events, routes them to on`Eventname` for each.
   * E.g. a `click` event will call `this.onClick`,
   * a focus event will call `this.onFocus`.
   * @param {Event} event - event.
   */
  handleEvent(event) {
    this[`on${event.type.charAt(0).toUpperCase() + event.type.slice(1)}`](
      event,
    );
  }

    /**
   * Highlight dropzone on drag enter.
   * @param {Event} event - on drag enter event.
   */
  onDragenter(event) {
    event.preventDefault();
    this.classList.add('highlight');
  }

  /**
   * Highlight dropzone on drag over.
   * @param {Event} event - on drag over event.
   */
  onDragover(event) {
    event.preventDefault();
    this.classList.add('highlight');
  }

  /**
   * Remove highlight from dropzone on drag leave.
   * @param {Event} event - on drag leave event.
   */
  onDragleave(event) {
    event.preventDefault();
    this.classList.remove('highlight');
  }

  /**
   * Handle files on drop and
   * remove highlight from dropzone.
   * @param {DragEvent} event - on drop event.
   */
  onDrop(event) {
    event.preventDefault();
    this.classList.remove('highlight');
    this.classList.add('selected');
    this.handleFiles(event.dataTransfer.files);
  }

    /**
   * Handle change on file input field.
   * @param {Event & { target: HTMLInputElement }} event - field on change event.
   */
  onChange(event) {
    event.preventDefault();
    this.classList.remove('highlight');
    this.classList.add('selected');
    this.handleFiles(event.target.files);
  }

  
    /**
   * Load files as data urls.
   * @param {FileList} files - list of files to handle.
   */
  handleFiles(files) {
    Array.from(files).forEach((file) => {
      this.documentNameElement.innerText = file.name;
    });
  }

}

if (customElements.get("input-file-drop") === undefined) {
  window.customElements.define("input-file-drop", InputFileDrop);
}
